import { ProductCategory as PCategory } from "../../classes";

const ProductCategory = {
  namespaced: true,
  state: {
    categories: []
  },
  actions: {
    createProductCategory: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        payload.projectId = rootGetters["markets/getProjectId"];
        const data = await PCategory.createProductCategory(payload);
        dispatch("getProductCategories");
        return data;
      } catch (err) {
        return false;
      }
    },
    getProductCategories: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const data = await PCategory.getProductCategoies({
          projectId: rootGetters["markets/getProjectId"]
        });
        commit("setCategory", { categories: data });
        return data;
      } catch (err) {
        console.error(err);
        return false;
      }
    },
    updateProductCategory: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const data = await PCategory.updateProductCategory(payload);
        dispatch("getProductCategories");
        return data;
      } catch (err) {
        return false;
      }
    }
  },
  getters: {
    getCategories: state => state.categories
  },
  mutations: {
    setCategory: (state, payload) => {
      state.categories = payload.categories;
    }
  }
};
export default ProductCategory;
